(function() {
    angular.module('tmx-app').controller('PersonalAssetsController', ['$mdDialog','$scope','PersonalAssets','showAddButton','guarantorTabEditPrivilege', 'ToastService', 'lookupService',
  
        function PersonalAssetsController($mdDialog,$scope,PersonalAssets,showAddButton,guarantorTabEditPrivilege,ToastService,lookupService) {
            $scope.vm = {};
            $scope.vm.PersonalAssetsData = PersonalAssets;
            $scope.vm.lookup = {};
            $scope.showOk = true;
            $scope.showAdd = showAddButton;
            $scope.guarantorTabEditPrivilege = guarantorTabEditPrivilege;
            $scope.vm.lookup.CollateralTypes = lookupService.getLocalLookupsByType('CollateralTypes');
  
            $scope.ok = function(form) {
                form.$submitted=true;
                if(form.$valid){
                    $mdDialog.hide();
                }
                else {
                    ToastService.showCustomToast("error","Form Invalid.");
                }
            };
            $scope.add = function(form) {
  
                form.$submitted=true;
                if(form.$valid){
                    $mdDialog.hide($scope.vm.PersonalAssetsData);
                }
                else {
                    ToastService.showCustomToast("error","Form Invalid.");
                }
  
            };
  
  
            $scope.cancel = function() {
                $mdDialog.hide();
            };

            $scope.collateralTypeChange = function(collateral){
                var selectedLookup = lookupService.getLookupById(collateral);
                if(selectedLookup){
                    $scope.vm.PersonalAssetsData.CollateralDescription = selectedLookup.VisibleValue;
                }
            }
  
  
        }]);
})();